//基础信息
export default [
  {
    path: '/rest/takeOutManage',
    component: () => import("../pages/takeOut/takeOutManage.vue"),
    name: 'takeOutManage',
    title: '外卖配置',
    meta: {
      title: '外卖配置',
    },
  },
  {
    path: '/takeOutGoods',
    component: () => import("../pages/takeOut/takeOutGoods.vue"),
    name: 'takeOutGoods',
    title: '外卖商品',
    meta: {
      title: '外卖商品',
    },
  },
  {
    path: '/rest/takeOutOrder',
    component: () => import("../pages/takeOut/takeOutOrder.vue"),
    name: 'takeOutOrder',
    title: '外卖订单',
    meta: {
      title: '外卖订单',
    },
  },
  {
    path: '/takeOutEvaluate',
    component: () => import("../pages/takeOut/takeOutEvaluate.vue"),
    name: 'takeOutEvaluate',
    title: '外卖评价',
    meta: {
      title: '外卖评价',
    },
  },
  {
    path: '/takeOutAddress',
    component: () => import("../pages/takeOut/takeOutAddress.vue"),
    name: 'takeOutAddress',
    title: '外卖地址',
    meta: {
      title: '外卖地址',
    },
  },
  {
    path: '/takeOutTime',
    component: () => import("../pages/takeOut/takeOutTime.vue"),
    name: 'takeOutTime',
    title: '外卖配送时间',
    meta: {
      title: '外卖配送时间',
    },
  },
  {
    path: '/recoTakeOut',
    component: () => import("../pages/takeOut/recoTakeOut.vue"),
    name: 'recoTakeOut',
    title: '外卖推荐',
    meta: {
      title: '外卖推荐',
    },
  },
  {
    path: '/takeOutSelfmention',
    component: () => import("../pages/takeOut/takeOutSelfmention.vue"),
    name: 'takeOutSelfmention',
    title: '自提点设置',
    meta: {
      title: '自提点设置',
    },
  },
]
